import * as React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { CheckboxInput } from "components";
import { globalStyles } from "styles";
import { Delete } from "@material-ui/icons";
export default function TwoTables({
  data,
  handleDeleteRow,
  handleCheckedSongPrimary,
  handleUpdateComposerData,
  handleCheckedComposer,
}) {
  const classes = globalStyles();
  return (
    <Box p={2}>
      <TableContainer component={Paper} sx={{ marginBottom: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Catalogue Song Title</TableCell>
              <TableCell>Song Title</TableCell>
              <TableCell>ISRC Code</TableCell>
              <TableCell>Artist</TableCell>
              <TableCell>DSP</TableCell>
              <TableCell align="right">Composer Share (%)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row" align="left">
                  <IconButton onClick={() => handleDeleteRow(row.id)}>
                    <Delete />
                  </IconButton>
                </TableCell>
                <TableCell component="th" scope="row" align="left">
                  <CheckboxInput
                    checked={row.is_primary_song === true}
                    onChange={() => handleCheckedSongPrimary(row.id)}
                  />
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.song_title}
                </TableCell>
                <TableCell component="th" scope="row">
                  <span className={classes.italicText}>
                    <strong>{row?.isrc_code}</strong>
                    {row?.alternate_isrc}
                  </span>
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.artist}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.dsp_name}
                </TableCell>

                <TableCell align="right">
                  {row.composer_share_percentage || 100}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <Typography variant="h6" gutterBottom>
        Child Table: Composer Data
      </Typography>  */}
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Composer Name</TableCell>
              <TableCell>Ownership %</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {// Kumpulkan composer_name yang unik, lalu tampilkan satu kali saja
            Array.from(
              data
                ?.flatMap(row =>
                  row.composer_data.map((composer, index) => ({
                    ...composer,
                    rowId: row.id,
                    index,
                  }))
                )
                .reduce((map, current) => {
                  const name = current.composer_name.trim();
                  if (!name) return map; // skip kosong
                  const existing = map.get(name);

                  // Update ownership jika baru != 0
                  if (!existing || current.ownership_percentage > 0) {
                    map.set(name, current);
                  }
                  return map;
                }, new Map())
                .values()
            ).map((composer, index) => (
              <TableRow
                key={`${composer.rowId}-${composer.composer_name}-${index}`}
              >
                <TableCell>
                  <CheckboxInput
                    checked={composer.is_checked}
                    onChange={() =>
                      handleCheckedComposer(
                        composer.rowId,
                        composer.index,
                        !composer.is_checked
                      )
                    }
                  />
                </TableCell>
                <TableCell>{composer.composer_name}</TableCell>
                <TableCell align="right">
                  <TextField
                    disabled={!composer.is_checked}
                    key={composer.composer_name + index}
                    value={composer.ownership_percentage}
                    onChange={e =>
                      handleUpdateComposerData(
                        composer.rowId,
                        composer.index,
                        e.target.value
                      )
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
